import ServerError from '@/common/utils/errors/ServerError';

export default class AuthorizationError extends ServerError {
  constructor(response?: Response, body?: ErrorBody) {
    super(response, body, undefined, 'Authorization error');

    this.message = (this.body as ErrorBody)?.error?.message
      || ((this.body as ErrorBody)?.message)
      || (response?.statusText)
      || 'Authorization error';
  }
}
